import { Brand } from '../../../../shared/model/brand.model';

export interface FindingSuggestionsQueryParams {
  brands: string[];
  regions: string[];
  countries: string[];
}

export interface FindingSuggestionsFilters {
  brands: Brand[];
  regions: string[];
  countries: string[];
}

export const emptyFindingSuggestionsFilters: FindingSuggestionsFilters = {
  brands: [],
  regions: [],
  countries: [],
};

export const convertFiltersInQueryParams = (filters: FindingSuggestionsFilters): FindingSuggestionsQueryParams => ({
  ...filters,
  brands: filters.brands.map(b => b.code),
});
